import BaseRepository from './BaseRepository';

export default class RequestsRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/requests';
    }

    getOpenQuotes()
    {
        return this.request('GET', `${this.getEndpoint()}/open-quotes`);
    }
}
